import React from "react";
import { Modal, ModalBody, ModalHeader, Row, Col } from "reactstrap";
import { urlDomain } from "../../../utils/services/config";

export default function ModalLinksEmbeded(props) {
  const { isOpen, toggle, idEvent } = props;

  async function clipBoard(url) {
    await navigator.clipboard.writeText(url);
    alert("O link foi copiado para a área de transferência");
  }

  return (
    <>
      <Modal isOpen={isOpen} centered>
        <ModalHeader toggle={toggle}>Links Para Embedar</ModalHeader>
        <ModalBody>
          <Row>
            <Col lg={12}>
              <label className="form-label">
                URL Hall
                <i
                  className="mdi mdi-content-copy"
                  style={{
                    color: "grey",
                    fontSize: 17,
                    marginLeft: 10,
                    cursor: "pointer",
                  }}
                  title="Copiar"
                  onClick={() =>
                    clipBoard(
                      `https://rankinghall-geral-site.${urlDomain}/ranking-hall?idEvent=${idEvent}&guest={NOME_PARTICIPANTE}&idGuest={CODIGOINTERNO}&backgroundColor=#eb0000&cardBackgroudColor=red&podiumTextColor=white&guestPointsCardBackground=gray&guestPointsCardColor=white`,
                    )
                  }
                />
              </label>
              <input
                className="form-control"
                disabled
                value={`https://rankinghall-geral-site.${urlDomain}/ranking-hall?idEvent=${idEvent}&guest={NOME_PARTICIPANTE}&idGuest={CODIGOINTERNO}&backgroundColor=#eb0000&cardBackgroudColor=red&podiumTextColor=white&guestPointsCardBackground=gray&guestPointsCardColor=white`}
              />
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={12}>
              <label className="form-label">
                URL APP Eventos
                <i
                  className="mdi mdi-content-copy"
                  style={{
                    color: "grey",
                    fontSize: 17,
                    marginLeft: 10,
                    cursor: "pointer",
                  }}
                  title="Copiar"
                  onClick={() =>
                    clipBoard(
                      `https://rankinghall-geral-site.${urlDomain}/ranking-hall?idEvent=${idEvent}&guest={PAXNOME}&idGuest={PAXID}&backgroundColor=#eb0000&cardBackgroudColor=red&podiumTextColor=white&guestPointsCardBackground=gray&guestPointsCardColor=white`,
                    )
                  }
                />
              </label>
              <input
                className="form-control"
                disabled
                value={`https://rankinghall-geral-site.${urlDomain}/ranking-hall?idEvent=${idEvent}&guest={PAXNOME}&idGuest={PAXID}&backgroundColor=#eb0000&cardBackgroudColor=red&podiumTextColor=white&guestPointsCardBackground=gray&guestPointsCardColor=white`}
              />
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
}
